<!--
 * @Description  : 
 * @Author       : XiaoLei
 * @Date         : 2021-03-26 17:55:09
 * @LastEditTime : 2025-10-12 16:42:34
 * @LastEditors  : BigBigger
-->
<template>
<div class="app-page-1">
  <div class="course-detail" v-if="detail">
    <div class="detail">
      <div class="detail-card">
        <div class="inc-content">
          <div class="title">{{detail.courseGroupName}}</div>
          <div class="tip red">{{detail.subtitle}}</div>
          <div class="tip-arrange">
            <p class="tip-time">
              <img src="@/assets/images/h5-icon/time.png">
              <span>时间：{{detail.classTime}} </span>
            </p>
            <p class="tip-type" v-if="teachers">
              <img src="@/assets/images/h5-icon/type.png">
              <span>大课授课老师：{{ teachers }}</span>
              <!-- <span>上课形式：{{detail.categoryName}}{{detail.classWay}} </span> -->
            </p>
            <p class="tip-address" v-if="detail.classLocation">
              <img src="@/assets/images/h5-icon/address.png">
              <span>上课地址：{{detail.classLocation}} </span>
            </p>
          </div>
        </div>
      </div>
      <div class="class-detail-card">
        <div class="inc-content">
          <div class="title">课程内容</div>
          <div class="content" v-html="detail.richText"></div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { getCourseGroupDetail } from "@/api/api"
export default {
  name: "CourseDetail",
  data() {
    return {
      courseId: null,
      detail:null,
    }
  },
  mounted() {
    this.getCourseGroupDetail()
  },
  methods: { 
    async getCourseGroupDetail () {
      let response = await getCourseGroupDetail({id: this.$route.params.id})
      if(+response.returnCode !== 10001) {
        return false
      }
      this.detail = response.data
      document.title = this.detail.courseGroupName
      wx.updateAppMessageShareData({
        title: document.title,
        desc: '深耕浙江本土公职辅导22年，选择博学 选择成 "公"', // 分享描述
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://bx-gwy-platform.oss-cn-hangzhou.aliyuncs.com/logo4.jpg', // 分享图标
        success: function () {
          // 设置成功

        }
      });

      wx.updateTimelineShareData({
        title: document.title,
        link: location.href,// 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://bx-gwy-platform.oss-cn-hangzhou.aliyuncs.com/logo4.jpg', // 分享图标
        success: function () {
          // 设置成功

        }
      });
    },
  },
  computed: {
    teachers() {
      return (this.detail.teachers || []).map(i => i.teacherName).join('、')
    }
  }
}
</script>

<style lang="less" scoped>
.course-detail{
  padding-bottom: 1rem;  
}
.detail{
  background:#F8F8F8;
}
.detail-card{
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding:0.2rem 0.4rem;
}
.class-detail-card{
  margin-top: 0.2rem;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding:0.2rem 0.4rem;
}
.inc-content{
  color:#333333;
  text-align: left;
  width:100%;
  font-size: 3.7777vw;
}
.inc-content .title{
  font-size: 22px;
  font-weight: 700;
  line-height: .65rem;
  padding: .15rem 0;
  
}
.inc-content .tip{
  color:#999999;
  font-size: 14px;
  line-height: 0.4rem;
  margin-bottom: 0.1rem;
}
.inc-content .tip-price1{
  // height:0.5rem;
  // line-height: 0.5rem;
  display: flex;
  padding:0.18rem 0;
  align-items: center;
}
.inc-content .tip-price1 .price-now{
  font-size: 20px;
  color:#FF3F47;
  font-weight: bold;
  margin-right: 0.15rem;
}
.inc-content .tip-price1 .price-old{
  font-size: 12px;
  color:#999999;
  text-decoration: line-through;
  margin-right: 0.15rem;
}
.inc-content .red{
  color:#FB4A3E;
}
.inc-content .tip-price1 .preferential{
  font-size: 14px;
}
.inc-content .tip-arrange{
  width:100%;
  overflow: hidden;
  background: #F8F8F8;
  border: 1px solid #DBDBDB;
  border-radius: 10px;
}
.inc-content .tip-arrange p{
  display: flex;
  height:0.4rem;
  line-height: 0.4rem;
  padding:0.2rem 0;
  font-size: 14px;
  margin:0 0.34rem;
  align-items: center;
}
.inc-content .tip-arrange .tip-time{
  border-bottom:1px #DBDBDB solid;
}
.inc-content .tip-arrange .tip-address{
  border-top:1px #DBDBDB solid;
}
.inc-content .tip-arrange p img{
  width:0.31rem;
  height: 0.31rem;
  margin-right: 0.2rem;
}
.inc-content .tip-matter{
  display: flex;
  height:0.4rem;
  line-height: 0.4rem;
  padding:0.35rem 0;
  font-size: 14px;
  margin:0.1rem 0;
  align-items: center;
}
.inc-content .tip-matter:not(:last-child){
  border-bottom:1px #DBDBDB solid;
}
.inc-content .tip-matter .matter-icon{
  width: 0.1rem;
  height: 0.1rem;
  background: #FB4A3E;
  border-radius: 50%;
  margin:0.14rem 0.2rem 0.15rem 0.1rem;
}
.inc-content .tip-matter .matter-title{
  font-size: 14px;
  color:#333333;
  font-weight: bold;
  margin-right:0.3rem;
}
.inc-content .tip-matter .matter-cont{
  flex-grow:2;
  color:#999;
}
.inc-content .tip-matter .matter-course{
  width:0.15rem;
  height:0.24rem;
  margin:0.04rem 0;
}
.inc-content .tip-matter .matter-course img{
  width:100%;
}
.inc-content .tip-matter .tip-address img{
  width: 0.34rem;
  height:0.35rem
}
.content2 .tip2{
  color:#333333;
  padding:5px 0;
  line-height: 0.5rem;;
}

::v-deep .content {
  img {
    max-width: 100%;
    height: auto;
  }
  table {
    max-width: 100%;
  }
}
</style>